import React from "react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  const dark = tone === "dark";
  return <div className="mx-auto mt-6 w-full max-w-xl" role="timer" aria-label={`Offer ends in ${hours}:${minutes}:${seconds}`} data-id="element-19" data-mp="3c0umf6ua8m7d">
      <p className={`text-center text-sm font-extrabold uppercase tracking-wide ${dark ? "text-sun" : "text-coral"}`} data-id="element-20" data-mp="3h2a9t5jxn4sx">
        Promotional price ends in
      </p>
      <div className="mt-2 flex items-start justify-center gap-2 sm:gap-3" data-id="element-21" data-mp="371zwlkxwdxdr">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-22" data-mp="10dekfqcbl5v8" data-mpi={i}>
            {i > 0 && <span className={`pt-2 font-display text-3xl font-bold ${dark ? "text-white/60" : "text-navy/40"}`} aria-hidden="true" data-id="element-23" data-mp="15b698bho4bv7">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-24" data-mp="t23fvpm39ziq">
              <span className={`w-[76px] rounded-xl py-2 text-center font-display text-[34px] font-bold tabular-nums leading-none sm:w-20 ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-25" data-mp="t1k8v3xz8vjh">
                {u.value}
              </span>
              <span className={`mt-1 text-[11px] font-bold uppercase tracking-wide ${dark ? "text-white/70" : "text-ink/60"}`} data-id="element-26" data-mp="f2kk7wagsgnb">
                {u.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}